export default __webpack_public_path__ + "assets/images/391dcf0481703e5cc40623ba3e69c272.jpg";